import { render, staticRenderFns } from "./UpdateFares.vue?vue&type=template&id=43d12478&scoped=true&"
import script from "./UpdateFares.vue?vue&type=script&lang=js&"
export * from "./UpdateFares.vue?vue&type=script&lang=js&"
import style0 from "./UpdateFares.vue?vue&type=style&index=0&id=43d12478&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d12478",
  null
  
)

export default component.exports